import axiosServices from "../utils/axios";
import { convertToCamelCase } from "../utils/code-utils";

import type { Activity } from "../utils/types/activities";

interface ApiResponse {
  data: Activity[];
  total: number;
}

export const fetchActivities = async (
  page: number,
  pageSize: number,
  hour: string | null,
  days: string | null,
  includeEtd: boolean = false
) => {
  const response = await axiosServices.get("/berthrotation", {
    params: {
      filter: "upcoming",
      page: page + 1,
      start: page * pageSize,
      limit: pageSize,
      hour,
      days,
      includeEtd,
    },
  });
  return convertToCamelCase<ApiResponse>(response.data);
};

export const fetchBerthrotationByJobId = async (jobId: string) => {
  try {
    const response = await axiosServices.get("/berthrotation", {
      params: {
        page: 1,
        start: 0,
        limit: 25,
        jobId,  // Added a comma here
      },
    });
    return response.data?.data;
  } catch (error) {
    console.error("Error fetching berth rotation data:", error);
    throw error;
  }
};

